<template>
    <el-dialog :title="title + '功能母版'" :fullscreen="true" :close-on-click-modal="false" append-to-body
               :visible.sync="visible">
        <div class="el-table-container" v-loading="loading">
            <el-form class="formItemBox" size="small" :model="form" :inline="true" ref="form" label-width="140px"
                     :rules="dataRule"
                     :disabled="method==='view'" @keyup.enter.native="doSubmit()" @submit.native.prevent>
                <div class="title b_b">基本信息</div>
                <el-form-item label="模板名称：" prop="modelName">
                    <el-input v-model.trim="form.modelName" placeholder="请输入模板名称（限50字）" clearable
                              maxlength="50"></el-input>
                </el-form-item>
                <el-form-item label="模板描述：" prop="modelDescription">
                    <el-input v-model.trim="form.modelDescription" type="textarea"
                              :rows="1" placeholder="请输入模板描述（限200字）" clearable
                              maxlength="200" v-if="visible"></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="modelRemake">
                    <el-input v-model.trim="form.modelRemake" type="textarea"
                              :rows="1" placeholder="请输入备注说明（限200字）" clearable
                              maxlength="200" v-if="visible"></el-input>
                </el-form-item>
                <el-form-item label="启用状态：" prop="disabled">
                    <el-switch v-model="form.disabled" active-value="0" inactive-value="1"></el-switch>
                </el-form-item>
            </el-form>
            <div class="title b_b p_t2">母版功能管理</div>
            <div class="flex_b_c m_b1">
                <div v-if="method != 'view'">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addEdit(null, 'add')">新增
                    </el-button>
                    <el-button type="danger" size="small" icon="el-icon-delete" @click="del()">批量删除</el-button>
                </div>
                <div class="flex_r_c">
                    <el-input class="m_r1" v-model.trim="searchForm.keyword" size="small" maxlength="50"
                              placeholder="请输入关键词" clearable @submit.native.prevent @keyup.enter.native="refreshList(1)"></el-input>
                    <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                    <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
                </div>
            </div>
            <el-table
                    :data="dataList"
                    size="small" height="100%"
                    class="table draggable" border ref="multipleTable" row-key='metadataFonctionsModelDetailId'
                    @selection-change="selectionChangeHandle">
                <el-table-column fixed type="selection" :reserve-selection="true" :selectable="checkSelectable"></el-table-column>
                <el-table-column prop="fonctionsNumber" label="功能标识ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="detailIcon" label="图标">
                    <template slot-scope="scope">
                        <div :class="[scope.row.detailIcon]"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="detailName" label="功能名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="detailType" label="功能类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{$dictUtils.getDictLabel("detailType", scope.row.detailType ,'')}}
                    </template>
                </el-table-column>
                <el-table-column prop="disabled" label="启用状态">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.disabled" active-value="0" inactive-value="1"
                                   :disabled="method == 'view'" @change="enabledChange(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-link icon="el-icon-rank" type="primary" class="allowDrag m_r1" :underline="false"
                                 v-if="method != 'view'"></el-link>
                        <el-button type="text" size="small"
                                   @click="addEdit(scope.row, 'view')">详情
                        </el-button>
                        <el-button type="text" size="small" v-if="method != 'view'"
                                   @click="addEdit(scope.row, 'edit')">修改
                        </el-button>
                        <el-button type="text" size="small" v-if="method != 'view'"
                                   :disabled="scope.row.disabled == '0'" @click="del(scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div slot="footer">
            <el-button size="small" @click="visible = false">{{method == 'view' ? '关闭' : '取消'}}</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick v-if="method != 'view'"
                       :disabled="loading">提交
            </el-button>
        </div>
        <FunctionForm ref="functionForm" @getDetailList="getDetailList"></FunctionForm>
    </el-dialog>
</template>

<script>
    import FunctionForm from './functionForm'
    import Sortable from 'sortablejs'

    export default {
        components: {FunctionForm},
        data() {
            return {
                visible: false,
                loading: false,
                title: '',
                method: '',
                form: {
                    modelName: '',
                    modelDescription: '',
                    modelRemake: '',
                    disabled: '0',
                    detailList: [],
                },
                dataRule: {
                    modelName: [
                        {required: true, message: '模板名称不能为空', trigger: 'blur'}
                    ],
                    disabled: [
                        {required: true, message: '启用状态不能为空', trigger: 'change'}
                    ],
                },
                searchForm: {
                    keyword: '',
                    current: 1,
                    size: 99999,
                },
                total: 0,
                dataListSelections: [],
                dataList: [],
            }
        },
        methods: {
            init(row, method) {
                this.searchForm.keyword = ''
                this.dataList = []
                this.form.detailList = []
                this.dataListSelections = []
                this.method = method
                if (method === 'add') {
                    this.title = `新增`
                } else if (method === 'edit') {
                    this.title = '修改'
                } else if (method === 'view') {
                    this.title = '查看'
                }
                if (row) {
                    this.form.id = row.id
                } else {
                    this.form.id = ''
                }
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                    this.$refs.multipleTable.clearSelection()
                    this.rowDrop();
                    if (method != 'add') {
                        this.getInfo()
                    }
                })
            },
            // 获取列表数据
            getInfo() {
                this.loading = true
                this.$axios(this.api.metadata.metadatafonctionsmodelGetById + '/' + this.form.id).then(data => {
                    if (data.status) {
                        this.form = this.recover(this.form, data.data);
                        this.refreshList(1)
                    }
                    this.loading = false
                })
            },
            // 获取新加的模板功能
            getDetailList(data) {
                if (data.method == 'add') {
                    this.form.detailList.push(data.form)
                } else {
                    this.form.detailList.map((item, index) => {
                        if (item.metadataFonctionsId == data.form.metadataFonctionsId) {
                            this.form.detailList.splice(index, 1, data.form)
                        }
                    })
                }
                this.refreshList()
            },
            refreshList(type) {
                if (type == 1) {
                    this.searchForm.current = 1
                }
                let list = this.form.detailList.filter(item => item.detailName.includes(this.searchForm.keyword))
                this.dataList = list.slice(
                    (this.searchForm.current - 1) * this.searchForm.size,
                    this.searchForm.current * this.searchForm.size
                );
                this.total = this.form.detailList.length
            },
            // 启用状态
            enabledChange(row) {
                let str = '', state = null
                // 启用
                if (row.disabled == '0') {
                    state = '1'
                    str = '启用后，该按钮将显示在【业务功能配置管理】的“页面功能选择或"列表功能选择”中，支持被引用，是否启用？'
                } else {
                    state = '0'
                    str = '禁用后，系统将收回该按钮在【业务功能配置管理】的引用，且已设置的"状态变更设置"逻辑会同步删除，是否继续?'
                }
                this.$confirm(str, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                }).catch(action => {
                    this.$set(row, 'disabled', state)
                });

            },
            // 新增编辑
            addEdit(row, method) {
                this.$refs.functionForm.init(row, method, this.form.detailList)
            },
            // 删除
            del(row) {
                console.log(row);
                if (!row && !this.dataListSelections.length) {
                    this.$message.warning('请至少选择一条数据')
                    return
                }
                let metadataFonctionsModelDetailId = []
                let metadataFonctionsId = []
                if (row) {
                    metadataFonctionsModelDetailId = [row.metadataFonctionsModelDetailId];
                    metadataFonctionsId = [row.metadataFonctionsId];
                } else {
                    metadataFonctionsModelDetailId = this.dataListSelections.map(item => {
                        return item.metadataFonctionsModelDetailId
                    })
                    metadataFonctionsId = this.dataListSelections.map(item => {
                        return item.metadataFonctionsId
                    })
                }
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (row && row.disabled == '0') {
                        this.delVerify(metadataFonctionsModelDetailId, metadataFonctionsId)
                    } else {
                        let list = []
                        this.dataListSelections.map(item => {
                            if (item.disabled == '0') {
                                list.push(item)
                            }
                        })
                        if (list.length) {
                            this.delVerify(metadataFonctionsModelDetailId, metadataFonctionsId)
                        } else {
                            this.delDetailList(metadataFonctionsId)
                        }
                    }
                })
            },
            // 删除校验
            delVerify(metadataFonctionsModelDetailId, metadataFonctionsId) {
                this.loading = true
                this.$axios(this.api.metadata.checkMetadataTableConfigPage, metadataFonctionsModelDetailId, 'post').then(data => {
                    if (data.status) {
                        this.delDetailList(metadataFonctionsId)
                    } else {
                        this.$message.error(data.msg)
                    }
                    this.loading = false
                })
            },
            // 删除功能
            delDetailList(ids) {
                this.form.detailList = this.form.detailList.filter(v => !ids.some(d => d == v.metadataFonctionsId))
                this.$message.success('删除成功')
                this.$refs.multipleTable.clearSelection()
                this.refreshList()
            },
            // 排序
            rowDrop() {
                let that = this
                const tbody = document.querySelector(".draggable .el-table__body-wrapper tbody");
                new Sortable(tbody, {
                    animation: 150,
                    ghostClass: "ghostClass",
                    handle: ".allowDrag",//设置操作区域
                    onEnd({newIndex, oldIndex}) {
                        // 拖拽排序数据
                        that.dataList.splice(newIndex, 0, that.dataList.splice(oldIndex, 1)[0])
                        that.form.detailList.splice(newIndex, 0, that.form.detailList.splice(oldIndex, 1)[0])
                        const newArray = that.dataList.slice(0)
                        const newArray2 = that.form.detailList.slice(0)
                        that.dataList = [] // 必须有此步骤，不然拖拽后回弹
                        that.form.detailList = []
                        that.$nextTick(function () {
                            that.dataList = newArray
                            that.form.detailList = newArray2
                        })
                    }
                })
            },
            // 重置
            reset() {
                this.$refs.multipleTable.clearSelection()
                this.searchForm.keyword = ''
                this.refreshList(1)
            },
            checkSelectable(row) {
                return row.disabled == '1'
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 确定
            doSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.$axios(this.api.metadata.metadatafonctionsmodelSave, this.form, 'post').then(data => {
                            if (data.status) {
                                this.$message.success('提交成功')
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .title {
        font-size: 14px;
        font-weight: bold;
        color: #000;
        padding-left: 20px;
        padding-bottom: 10px;
        margin-bottom: 10px;
    }

    .formItemBox .el-form-item {
        width: 32% !important;
    }

    .formItemBox >>> .el-form-item__content {
        width: calc(100% - 140px) !important;
    }
</style>
